export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6974.c61b4525.jpg";